import * as IconSelector from '../icons';

export const TIPO_OPERACION_NORMAL = 'Normal';
export const TIPO_OPERACION_RECTIFICATIVA = 'Rectificativa';
export const TIPO_OPERACION_EXENTA = 'Exenta';
export const TIPO_OPERACION_RETENCION = 'Retencion';

export const tiposOperacionVenta = [
    {
        value: TIPO_OPERACION_NORMAL,
        label: TIPO_OPERACION_NORMAL,
        description: 'Operación normal con IVA',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: TIPO_OPERACION_RETENCION,
        label: TIPO_OPERACION_RETENCION,
        description: 'Operación con IVA y retención',
        icon: IconSelector.PointIcon,
        color: 'Brown'
    },
    {
        value: TIPO_OPERACION_RECTIFICATIVA,
        label: TIPO_OPERACION_RECTIFICATIVA,
        description: 'Operación rectificativa con o sin IVA',
        icon: IconSelector.PointIcon,
        color: 'Red'
    },
    {
        value: TIPO_OPERACION_EXENTA,
        label: TIPO_OPERACION_EXENTA,
        description: 'Operación exenta de IVA',
        icon: IconSelector.PointIcon,
        color: 'Orange'
    }
];
